export const MODULE_NAME = "TABLE";

export const ReviewList = {
	SEARCH_TEXT: "searchValue",
	SEARCH_BY: "searchColumn",
};

const constants = {
	NAME_LABEL: "Name",
	STATUS_LABEL: "Status",
	SOURCE_LABEL: "Source",
	TYPE_LABEL: "Type",
	START_DATE: "Start Date",
	END_DATE: "End Date",
	SEARCH_LABEL: "Search",
	DELETE: "DELETE",
	APPLY: "APPLY",
	FILTER: "Filters",
	CLEAR_ALL: "Clear All",
	SEND: "SEND",
	COPY_NAME: "COPY NAME",
	COPY_QUERY: "COPY QUERY",
	ROWS_PER_PAGE: [5, 10, 15, 50],
	LOG_OUT: "Logout",
	PROFILE: "Profile",
	CANCEL: "CANCEL",
	SAVE: "SAVE",
	AMOUNT: "Amount",
	CLEAR: "Clear",
	NOT_ASSIGNED: "Not Assigned",
	QUEUES: "Queues",
};

export const SEARCH_LIST = {
	SEARCH_TEXT: "searchValue",
	SEARCH_BY: "searchColumn",
};

export const tableListTypes = {
	TRANSACTION_HISTORY_LIST: "transactionHistoryList",
	PENDING_TRANSACTIONS_LIST: "pendingTransactionsList",
};

export const COLUMN_KEY = {
	EXTERNAL_ORDER_ID: "externalOrderId",
	PURCHASE_ID: "purchaseId",
	CUSTOMER_NAME: "customerName",
	CUSTOMER_EMAIL: "customerEmail",
	CUSTOMER_MOBILE_NUMBER: "customerMobile",
	STORE_NAME: "storeName",
	CREATION_DATE: "creationDate",
	SETTLEMENT_DATE: "settlementDate",
	PURCHASE_AMOUNT: "purchaseAmount",
	ACTION: "action",
	NAME: "name",
	QUERY: "query",
	STATUS: "status",
	SUB_STATUS: "subStatus",
	IS_ACTION: "isAction",
	DELIVERY_ORDER: "showDeliveryOrder",
	UPLOAD_INVOICE: "uploadInvoice",
};

export const TABLE_ACTION_TYPES = {
	LINK: "Link",
	STATUS_BUTTON: "StatusButton",
	INPUT_ACTION: "InputAction",
	OPEN_ATTACHMENT: "OpenAttachment",
};

export const TABLE_COLUMN_ACTION = {
	OPEN_LINK: "OPEN_LINK",
	OPEN_ISSUE_DETAILS: "OPEN_ISSUE_DETAILS",
	SAVE: "SAVE",
	CALL: "CALL",
	COPY_NAME: "COPY NAME",
	COPY_QUERY: "COPY QUERY",
	UPLOAD_INVOICE: "UPLOAD_INVOICE",
	VIEW_INVOICE: "VIEW_INVOICE",
	DOWNLOAD_INVOICE: "DOWNLOAD_INVOICE",
	VIEW_DELIVERY: "VIEW_DELIVERY",
	DOWNLOAD_DELIVERY: "DOWNLOAD_DELIVERY",
};

export const GRID_HEADERS = {
	EXTERNAL_ORDER_ID: "External Order Id",
	PURCHASE_ID: "Purchase ID",
	CUSTOMER_NAME_AND_EMAIL: "Name and Email",
	CUSTOMER_NAME: "Customer Name",
	CUSTOMER_EMAIL: "Customer Email",
	CUSTOMER_MOBILE_NUMBER: "Mobile Number",
	STORE_NAME: "Store Name",
	CREATION_DATE: "Date of Creation",
	SETTLEMENT_DATE: "Settlement Date",
	PURCHASE_AMOUNT: "Purchase Amount",
	STATUS: "Status",
	SUB_STATUS: "Sub Status",
	ACTION: "Action",
	DELIVERY_ORDER: "Delivery Order",
	UPLOAD_INVOICE: "Invoice",
};

export const FILTER_ACTIONS = {
	QUEUE_TYPE: "QUEUE_TYPE",
	RESET: "RESET",
	SUB_QUEUE: "SUB_QUEUE",
	APPLY: "APPLY",
	CANCEL: "CANCEL",
};

export enum SORT_ORDER {
	DESC = "desc",
	ASC = "asc",
}

export const GRID_HEADERS_IMAGE_UPLOAD = {
	NAME: "Name",
	S3_URL: "S3 Url",
	DATE_CREATED: "Date Created",
	DESCRIPTION: "Description",
	S3_KEY: "S3 Key",
};

export const COLUMN_KEY_IMAGE_UPLOAD = {
	NAME: "name",
	S3_URL: "s3Url",
	DATE_CREATED: "dateCreated",
	DESCRIPTION: "description",
	S3_KEY: "s3Key",
};

export const GRID_HEADERS_CIBIL_UPLOAD = {
	ID: "Id",
	FILE_PATH: "File Path",
	DATE_CREATED: "Date Created",
	SUCCESSFUL_ENTRIES: "Successful Entries",
	TOTAL_ENTRIES: "Total Entries",
	ERROR: "Error",
	STATUS: "Status",
};

export const COLUMN_KEY_CIBIL_UPLOAD = {
	ID: "id",
	FILE_PATH: "filePath",
	DATE_CREATED: "dateCreated",
	SUCCESSFUL_ENTRIES: "successfulEntries",
	TOTAL_ENTRIES: "totalEntries",
	ERROR: "error",
	STATUS: "status",
};

export default constants;
